import { render, staticRenderFns } from "./ProductSliderList.vue?vue&type=template&id=1af0cdba"
import script from "./ProductSliderList.vue?vue&type=script&lang=js"
export * from "./ProductSliderList.vue?vue&type=script&lang=js"
import style0 from "./ProductSliderList.vue?vue&type=style&index=0&id=1af0cdba&prod&lang=scss"
import style1 from "./ProductSliderList.vue?vue&type=style&index=1&id=1af0cdba&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/app/components/Loading.vue').default,ProductSliderListItem: require('/app/components/ProductSliderListItem.vue').default})
